{
    "$id": "https://github.com/LIT-Protocol/accs-schemas/blob/main/src/generated/LPACC_EVM_ATOM.ts",
    "title": "LPACC_EVM_ATOM",
    "description": "",
    "type": "object",
    "properties": {
        "conditionType": {
            "type": "string"
        },
        "path": {
            "type": "string"
        },
        "chain": {
            "enum": ["cosmos", "kyve", "evmosCosmos", "evmosCosmosTestnet"]
        },
        "method": {
            "type": "string"
        },
        "parameters": {
            "type": "array",
            "items": {
                "type": "string"
            }
        },
        "returnValueTest": {
            "type": "object",
            "properties": {
                "key": {
                    "type": "string"
                },
                "comparator": {
                    "enum": ["contains", "=", ">", ">=", "<", "<="]
                },
                "value": {
                    "type": "string"
                }
            },
            "required": ["key", "comparator", "value"],
            "additionalProperties": false
        }
    },
    "required": ["path", "chain", "returnValueTest"],
    "additionalProperties": false
}
